import { z } from 'zod';

/**
 * "Ver como" del superadmin (§8.6): sólo lectura, con motivo, 30 min. Módulo sin dependencias de
 * otros contratos (lo importa `me.ts`, que está en la base del grafo de imports).
 */
export const IMPERSONATION_MINUTES = 30;

export const startImpersonationSchema = z.object({
  userId: z.uuid(),
  reason: z.string().trim().min(10, { error: 'Contá el motivo (mínimo 10 caracteres)' }).max(500),
});

export const impersonationInfoSchema = z.object({
  id: z.uuid(),
  targetUserId: z.uuid(),
  targetEmail: z.string(),
  targetName: z.string(),
  realUserEmail: z.string(),
  reason: z.string(),
  expiresAt: z.string(),
  readOnly: z.literal(true),
});
export type ImpersonationInfo = z.infer<typeof impersonationInfoSchema>;
